/**
 * React entry point.
 *
 * Phase: 0
 * Status: STUB
 *
 * When implemented:
 *   - Mount React root, wrap in MantineProvider, QueryClientProvider, RouterProvider
 *   - Phase 0 minimum: just render <App /> to verify the build pipeline works.
 */

// TODO(phase 0): wire MantineProvider + QueryClientProvider + Router after Phase 3.

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
